
import { inject, Injectable, DOCUMENT } from '@angular/core';
import { Router } from '@angular/router';
import { Url } from '@df/core/service/url';
import { TimeoutService } from '@df/ng/timeout.service';

@Injectable({
    providedIn: 'root'
})
export class InternalLinksService {
    private readonly document = inject(DOCUMENT);

    constructor(private timeoutService: TimeoutService, private url: Url, private router: Router) { }

    bind(element: HTMLElement) {
        const onClick = (event: MouseEvent) => {
            const aTag = (<HTMLAnchorElement>event.target).closest('a');
            const routerLink = aTag?.href.replace(this.url.storeUrl, '');

            if (routerLink) {
                const isExternalLink = routerLink.includes('http');
                const hasTargetBlank = aTag?.target === '_blank';

                if (hasTargetBlank || isExternalLink) {
                    this.document.defaultView?.open(routerLink, '_blank');
                    event.preventDefault();
                    return;
                  }

                event.preventDefault();
                this.router.onSameUrlNavigation = 'reload';
                this.timeoutService.ngZone.run(() => {
                    this.router.navigateByUrl(routerLink);
                });
            }
        };

        this.timeoutService.async(() => {
            Array.from(element.querySelectorAll('a')).forEach((linkEl: HTMLAnchorElement) => {
                if (!linkEl.pathname.includes('.') && linkEl.href.includes(this.url.storeUrl)) {
                    linkEl.addEventListener('click', onClick);
                }
            });
        });
    }
}
